"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedProductInDetailWithoutProductResponse = exports.mockedProductInDetailResponse = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const omit_util_1 = require("../../utils/omit.util");
const product_1 = require("../product");
const product_material_1 = require("../product-material");
const product_project_1 = require("../product-project");
exports.mockedProductInDetailResponse = {
  id: 1,
  type: common_interfaces_1.ProductType.material,
  material: product_material_1.mockedProductMaterialWithoutInDetailResponse,
  projects: [product_project_1.mockedProductProjectWithoutInDetailResponse],
  subscription: null,
  product: product_1.mockedProductResponse
};
exports.mockedProductInDetailWithoutProductResponse = omit_util_1.omitObject(exports.mockedProductInDetailResponse, 'product');